export enum ApiType {
  Mock = 'mock',
  Rest = 'rest',
  MetaMask = 'metamask',
  MBaas = 'mbaas',
  Amp = 'amp',
  Navbar = 'navbar',
}
